const ReportIcon = () => {
    return ( 
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 16.5H11.5M6.5 16.5V12.3333M6.5 16.5H2C1.86739 16.5 1.74021 16.4473 1.64645 16.3536C1.55268 16.2598 1.5 16.1326 1.5 16V12.8333C1.5 12.7007 1.55268 12.5735 1.64645 12.4798C1.74021 12.386 1.86739 12.3333 2 12.3333H6.5M11.5 16.5V6.5M11.5 16.5H16C16.1326 16.5 16.2598 16.4473 16.3536 16.3536C16.4473 16.2598 16.5 16.1326 16.5 16V2C16.5 1.86739 16.4473 1.74021 16.3536 1.64645C16.2598 1.55268 16.1326 1.5 16 1.5H12C11.8674 1.5 11.7402 1.55268 11.6464 1.64645C11.5527 1.74021 11.5 1.86739 11.5 2V6.5M11.5 6.5H7C6.86739 6.5 6.74021 6.55268 6.64645 6.64645C6.55268 6.74021 6.5 6.86739 6.5 7V12.3333" stroke="#4D4D4D" stroke-width="1.2" className="stroke"/>
        </svg>

    );
}
 
export default ReportIcon;